module.exports = __webpack_public_path__ + "static/Infographic4_6_Kaohsiung-139b125222debef771b6b2e2579def2f.png";